import React from "react";
import { ArrowLeft, ProfileTick, Timer, UserEdit } from "iconsax-react";

function TaskListBox({
	filteredTasks,
	filter,
	setFilter,
	setSelectedTask,
	openAddTaskModal,
	selectedDay,
	jalaliSelectedDay,
	getPersianDateLabel,
	hasPending,
}) {
	const taskListTab = [
		{
			title: "تسک های در حال انجام",
			filterName: "ongoing",
			order: 0,
		},
		{
			title: "تسک های انجام شده",
			filterName: "completed",
			order: 1,
		},
		hasPending
			? {
					title: "تسک های در انتظار",
					filterName: "pending",
					order: 2,
				}
			: {},
	];

	if (hasPending) {
		taskListTab.push();
	}

	return (
		<>
			<div className="tasklist-tabs tw-flex-row tw-overflow-auto tw-w-full tw-flex-shrink-0">
				{taskListTab.map((task, index) => (
					<span
						key={task.title}
						className={`tab tw-text-center  tw-min-w-[80px] ${filter === task.filterName ? "active" : ""}`}
						onClick={() => setFilter(task.filterName)}
					>
						{task.title}
					</span>
				))}
				{/*<span className={`tab ${filter === 'ongoing' ? 'active' : ''}`} onClick={() => setFilter('ongoing')}>*/}
				{/*  تسک های در حال انجام*/}
				{/*</span>*/}
				{/*        <span className={`tab ${filter === 'completed' ? 'active' : ''}`}*/}
				{/*              onClick={() => setFilter('completed')}>*/}
				{/*  تسک های انجام شده*/}
				{/*</span>*/}
				{selectedDay && (
					<span
						className={`tab tw-text-center tw-min-w-[80px] ${filter === "selectedDay" ? "active" : ""}`}
						onClick={() => setFilter("selectedDay")}
					>
						تسک های روز {getPersianDateLabel(selectedDay)}
						<span
							className="tab-close-btn"
							onClick={(e) => {
								e.stopPropagation();
								setFilter("ongoing");
							}}
							style={{
								marginRight: 8,
								marginLeft: 0,
								cursor: "pointer",
								color: "#7A7A7A",
								fontWeight: "bold",
								// fontSize: 18
							}}
							title="بستن تب روز"
						>
							×
						</span>
					</span>
				)}
			</div>
			<div className={"tw-overflow-hidden"}>
				<div className="tasklist-list">
					{filteredTasks.length === 0 ? (
						<div className="tasklist-empty">هیچ تسکی وجود ندارد</div>
					) : (
						filteredTasks.map((task) => (
							<div
								className="tasklist-card"
								key={task.id}
								onClick={() => setSelectedTask(task.id)}
							>
								<div className="tasklist-status">{/* Status icon here */}</div>
								<div className="tasklist-content">
									<div className="tasklist-title">{task.title}</div>
									<div className="tasklist-meta">
										<span style={{ display: "flex", alignItems: "center" }}>
											<UserEdit
												size={16}
												style={{ marginLeft: 8 }}
												variant="Linear"
											/>
											تعریف کننده: {task?.assigner?.fname}{" "}
											{task?.assigner?.lname}
										</span>
										<span style={{ display: "flex", alignItems: "center" }}>
											<ProfileTick
												size={18}
												style={{ marginLeft: 8 }}
												variant="Linear"
											/>
											انجام دهنده: {task.assigned_user?.fname}{" "}
											{task.assigned_user?.lname}
										</span>
										<span style={{ display: "flex", alignItems: "center" }}>
											<Timer
												size={18}
												style={{ marginLeft: 8 }}
												variant="Linear"
											/>
											ددلاین:{" "}
											{new Date(task.deadline).toLocaleDateString("fa-IR")}
										</span>
									</div>
								</div>
								<div className="tasklist-arrow-left">
									<ArrowLeft size={16} color="#0052CC" variant="Linear" />
								</div>
							</div>
						))
					)}
				</div>
			</div>
			<div className="tw-flex tw-w-full tw-justify-center tw-items-center tw-mt-3">
				<button
					type="button"
					className="tasklist-add-btn"
					onClick={openAddTaskModal}
				>
					<span>+ افزودن تسک جدید</span>
				</button>
			</div>
		</>
	);
}

export default TaskListBox;
